import http from './http'
import {
  normalizeFavoritesResponse,
  normalizeHistoryResponse
} from './dramaApiHelpers'

function parseIsNotOrganic (raw) {
  const value = raw.isNotOrganic ?? raw.is_not_organic
  if (value === true || value === 1 || value === '1' || value === 'true') return true
  return false
}

function normalizeUserInfo (data) {
  if (!data || typeof data !== 'object') return null
  const raw = data.userInfo ?? data
  if (!raw || typeof raw !== 'object') return null

  const uid = raw.uid ?? raw.uId ?? raw.userId ?? ''
  if (!uid) return null

  return {
    uid,
    uId: raw.uId ?? uid,
    nickname: raw.nickname ?? raw.username ?? raw.userName ?? '',
    avatar: raw.avatar ?? '',
    email: raw.email ?? null,
    loginFrom: raw.loginFrom ?? 0,
    vip: raw.vip ?? false,
    vipExpireAt: raw.vipExpireAt ?? null,
    watchCoins: raw.watchCoins ?? 0,
    watchBonus: raw.watchBonus ?? raw.watchBonusCoins ?? 0,
    isNotOrganic: parseIsNotOrganic(raw)
  }
}

function normalizeUserDetailResponse (data) {
  const userInfo = normalizeUserInfo(data)
  if (!userInfo) return null
  return { userInfo }
}

/** user/detail：设备静默登录 & 获取当前用户信息 */
export const getUserDetail = async () => {
  const data = await http.get('/api/user/detail')
  return normalizeUserDetailResponse(data)
}

/** @deprecated 使用 getUserDetail，保留别名供现有调用 */
export const registerWithDeviceId = async () => {
  return getUserDetail()
}

/** @deprecated 使用 getUserDetail，保留别名供现有调用 */
export const getUserInfo = async () => {
  return getUserDetail()
}

// 第三方账号登录（Facebook/Google）
export const loginWithThirdParty = (loginFrom, oauthToken, deviceId) => {
  const data = {
    loginFrom: loginFrom,
    oauthToken: oauthToken,
    deviceId: deviceId
  }
  return http.post('/api/user/login/oauth', data)
}

// 获取用户播放历史
export const getWatchHistory = async (page, pageSize) => {
  const data = {
    page: page,
    pageSize: pageSize
  }
  const result = await http.get('/api/user/history', data)
  return normalizeHistoryResponse(result)
}

// 获取用户收藏列表
export const getFavoriteList = async (page, pageSize) => {
  const data = {
    page: page,
    pageSize: pageSize
  }
  const result = await http.get('/api/user/favorites', data)
  return normalizeFavoritesResponse(result)
}
